import * as React from "react";
import { useSearchParams } from "react-router-dom";
import { LoadingDots } from "web-ui";

import DuoErrorScreen, { DuoErrorType } from "components/DuoErrorScreen";
import SourceContext from "components/SourceContext";
import { getUserId } from "util/auth";
import { getLoggedOutUuid } from "util/cookie";
import { init as initTracking } from "util/tracking";

interface Props {
  children: React.ReactNode;
}

const LoginGuard = ({ children }: Props) => {
  const [params] = useSearchParams();

  const [source] = React.useState(params.get("source"));

  // Ensure initTracking() has been called before rendering children.
  // Otherwise, the <Dashboard/> element may track release_dashboard_show_home
  // before the user has been properly identified.
  const [trackingReady, setTrackingReady] = React.useState(false);

  const loggedOutUuid = getLoggedOutUuid();
  const userId = getUserId();

  React.useEffect(() => {
    initTracking({
      debug: !!process.env.REACT_APP_EXCESS_ORIGIN?.includes("excess-dev"),
      loggedOutUuid,
      userAgent: navigator.userAgent,
      userId,
    });
    setTrackingReady(true);
  }, [loggedOutUuid, userId]);

  return trackingReady ? (
    <SourceContext.Provider value={source}>
      {source !== null || userId ? (
        children
      ) : (
        <DuoErrorScreen errorType={DuoErrorType.NotLoggedIn} />
      )}
    </SourceContext.Provider>
  ) : (
    <LoadingDots type="screen-white" />
  );
};

export default LoginGuard;
